import * as React from "react";

import { cva, type VariantProps } from "~/lib/utils";

/** P0-11 · Badge. Semantic tones map to token pairs (AA-audited in P0-DB01). */
export const badgeVariants = cva({
  base: "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
  variants: {
    tone: {
      neutral: "bg-surface-2 text-fg-muted",
      primary: "bg-primary text-primary-fg",
      success: "bg-success text-success-fg",
      warning: "bg-warning text-warning-fg",
      danger: "bg-danger text-danger-fg",
      info: "bg-info text-info-fg",
      outline: "border border-border text-fg",
    },
  },
  defaultVariants: { tone: "neutral" },
});

export function Badge({
  className,
  tone,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={badgeVariants({ tone, className })} {...props} />;
}
